export enum enmQuotaType {
    Guarantee,
    Normal,
    OnRequest,
    Mix
}